import React, { useState} from "react";
import { FcAlphabeticalSortingAz, FcAlphabeticalSortingZa } from "react-icons/fc";
import { elakayAutoText, getElakayLanguageContext } from "./dataElakay";
import { orderStatusLabel } from "../pages/purchased/OrderStatusBadge";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["filtersIncomme"]?.[key] || fallback;

// Technical order-status values sent to the API (the stored enum, never translated).
const STATUS_VALUES = ["Not processed", "Processing", "Shipped", "Delivered", "Cancelled", "Return Back"];
const getStatusList = () => [...STATUS_VALUES];

const ROLE_LIST = [
  "Family",
  "Administrator",
  "Investment",
  "Associate",
  "Provider",
  "Seller",
  "Royalty",
  "User"
];

const FiltersIncomme = props =>{
    const { 
        infoSource,
        laguangeElakay,
        limit, 
        setLimit,
        setFiltOrders,
        setShowFilterOrder,
        filtOrders
    }=props
    __setElakayInfoSource(infoSource);

    // let status = [{value: "All Status", name: 'allStatus'}, {value: "Not processed", name: 'notProcessed'}, {value: "Processing", name:'processing'},{value: "Shipped", name: 'shipped'}, {value: "Delivered", name:'delivered'}, {value: "Cancelled", name:'cancelled'}] 
    // let statusName = ["Not processed", "Processing", "Shipped", "Delivered", "Cancelled"] 
    // const incommeList = [{value: 'all Incomme', name: "allIncomme"}, {value:'Incomme as Seller', name:"IncommeAsSeller"}, {value: 'Incomme for my User Royalty', name:'Royalty'}, {value: 'Incomme for my Seller', name:'Seller'}, {value: 'Incomme for my Provider', name:'Provider'}, {value: 'Incomme for my Associate', name:'Associate'}, {value: 'Incomme for my Investment', name:'Investment'}, {value: 'Incomme for my Administrator', name:'Administrator'}, {value: 'Incomme for my Familly', name:'Family'}]
   // name = the stored value (filter state / API), label = display text in the active language.
   const status = [
  { name: "allStatus", get label() { return elakayAutoText("h_6405179d241bf8", "All statuses"); } },
  ...["Not processed", "Processing", "Shipped", "Delivered", "Cancelled"].map((value) => ({ name: value, label: orderStatusLabel(value) })),
];


    const incommeList = [
  { name: "allIncomme", get label() { return elakayAutoText("h_inc_all", "All income"); } },
  { name: "Royalty", get label() { return elakayAutoText("h_inc_role_royalty", "Income from my Royal Users"); } },
  { name: "Seller", get label() { return elakayAutoText("h_inc_role_seller", "Income from my Sellers"); } },
  { name: "Provider", get label() { return elakayAutoText("h_inc_role_provider", "Income from my Providers"); } },
  { name: "Associate", get label() { return elakayAutoText("h_inc_role_associate", "Income from my Associates"); } },
  { name: "Investment", get label() { return elakayAutoText("h_inc_role_investment", "Income from my Investors"); } },
  { name: "Administrator", get label() { return elakayAutoText("h_inc_role_administrator", "Income from my Administrators"); } },
  { name: "Family", get label() { return elakayAutoText("h_inc_role_family", "Developer income"); } },
];
    let date = ['days', 'months', 'years', 'date']
  
    const updateOrdersReadyToPay = (orderStatusArray) => {
  return (
    orderStatusArray.length === 1 &&
    orderStatusArray[0] === "Delivered"
  );
};


const handleChange = (event) => {
  const { name, value, type, checked } = event.target;

  // ----------------------------------------------------------
  // 1) ALL STATUS  → Select / Unselect everything
  // ----------------------------------------------------------
  if (name === "allStatus") {
    const all = checked ? getStatusList() : [];
    return setFiltOrders(prev => ({
      ...prev,
      orderStatus: all,
      OrdersReadyToPay: updateOrdersReadyToPay(all)
    }));
  }

  // ----------------------------------------------------------
  // 2) ALL INCOMME  → Select / Unselect all roles
  // ----------------------------------------------------------
  if (name === "allIncomme") {
    return setFiltOrders(prev => ({
      ...prev,
      roneName: checked ? ROLE_LIST : []
    }));
  }

  // ----------------------------------------------------------
  // 3) CHECKBOX NORMAL (orderStatus / roneName)
  // ----------------------------------------------------------
  if (type === "checkbox") {
    return setFiltOrders(prev => {
      const list = prev[name] || [];

      let updatedList = checked
        ? [...list, value]                  // ADD
        : list.filter(v => v !== value);   // REMOVE

      return {
        ...prev,
        [name]: updatedList,
        // update OrdersReadyToPay AUTOMATICALLY
        ...(name === "orderStatus" && {
          OrdersReadyToPay: updateOrdersReadyToPay(updatedList)
        })
      };
    });
  }

  // ----------------------------------------------------------
  // 4) ORDER DATE  → auto update myd
  // ----------------------------------------------------------
  if (name === "orderDate") {
    let newMyd = 6; // default

    if (value === "days") newMyd = 15;
    if (value === "months") newMyd = 6;
    if (value === "years") newMyd = new Date().getFullYear();

    return setFiltOrders(prev => ({
      ...prev,
      orderDate: value,
      myd: newMyd
    }));
  }

  // ----------------------------------------------------------
  // 5) nlimit (pagination)
  // ----------------------------------------------------------
  if (name === "nlimit") {
    return setFiltOrders(prev => ({
      ...prev,
      nlimit: value === "Endless" ? "Endless" : Number(value)
    }));
  }

  // ----------------------------------------------------------
  // 6) OrdersReadyToPay (boolean switch)
  // ----------------------------------------------------------
  if (name === "OrdersReadyToPay") {
    const boolValue = checked;

    // IF ON → force Delivered only
    if (boolValue) {
      return setFiltOrders(prev => ({
        ...prev,
        orderStatus: ["Delivered"],
        OrdersReadyToPay: true
      }));
    }

    // IF OFF → just disable boolean
    return setFiltOrders(prev => ({
      ...prev,
      OrdersReadyToPay: false
    }));
  }

  // ----------------------------------------------------------
  // 7) NORMAL INPUTS (myd, incomme, etc.)
  // ----------------------------------------------------------
  setFiltOrders(prev => ({
    ...prev,
    [name]: value
  }));
};

// const handleChange = (event) => {
//     const { name, value, type, checked } = event.target;

//     // -------------------------
//     // 1) CHECKBOX : ALL STATUS
//     // -------------------------
//     if (name === "allStatus") {
//         return setFiltOrders(prev => ({
//             ...prev,
//             orderStatus: checked ? STATUS_LIST : []
//         }));
//     }

//     // ----------------------------
//     // 2) CHECKBOX : ALL INCOMME
//     // ----------------------------
//     if (name === "allIncomme") {
//         return setFiltOrders(prev => ({
//             ...prev,
//             roneName: checked ? ROLE_LIST : []
//         }));
//     }

//     // ----------------------------
//     // 3) CHECKBOX NORMAL (array)
//     // ----------------------------
//     if (type === "checkbox") {
//         return setFiltOrders(prev => {
//             const list = prev[name] || [];   // ex: roneName ou orderStatus

//             if (checked) {
//                 if (list.includes(value)) return prev;
//                 return {
//                     ...prev,
//                     [name]: [...list, value]
//                 };
//             }

//             return {
//                 ...prev,
//                 [name]: list.filter(v => v !== value)
//             };
//         });
//     }

//     // ----------------------------
//     // 4) SELECT orderDate (auto-change myd)
//     // ----------------------------
//     if (name === "orderDate") {
//         let newMyd = 6;

//         if (value === "days") newMyd = 15;
//         if (value === "years") newMyd = 2024;

//         return setFiltOrders(prev => ({
//             ...prev,
//             orderDate: value,
//             myd: newMyd
//         }));
//     }
    
//    // SI c’est le choix du date dynamique (jours/mois/année)
//     if (name === "myd") {
//         return setFiltOrders(prev => ({
//             ...prev,
//             myd: value
//         }));
//     }

//   if (name === "limit") {
//     return setFiltOrders(prev => ({
//       ...prev,
//       limit: value === "Endless" ? "Endless" : Number(value)
//     }));
//   }
//     // ----------------------------
//     // 5) INPUT NORMAL
//     // ----------------------------
//     setFiltOrders(prev => ({
//         ...prev,
//         [name]: value
//     }));
// };


const btnfilter = () => {
    // appliquer la pagination choisie
    setLimit(filtOrders.limit);

    // fermer le modal de filtre
    setShowFilterOrder(false);

    // IMPORTANT : "soumettre" les filtres revient à re-déclencher setFiltOrders
    setFiltOrders(prev => ({
        ...prev
    }));
};


const btnClrfilter = () => {
    setLimit(3);                 // pagination par défaut
    setShowFilterOrder(false);   // fermer le modal

    setFiltOrders({
        roneName: [],            // aucun rôle sélectionné
        orderStatus: [],         // aucun status sélectionné
        orderDate: "months",     // filtre par mois
        limit: 50,              // si toujours utilisé
        myd: 6,                 // pagination
        asc: "desc",             // tri par défaut
    });
};

const sortDirectionStyles = {
    container: {
        display: "flex",
        gap: "12px",
        margin: "16px 0",
    },
    button: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        padding: "10px",
        fontSize: "22px",
        borderRadius: "8px",
        border: "2px solid #DCDCDC",
        backgroundColor: "#fff",
        cursor: "pointer",
    },
    active: {
        borderColor: "#258ecd",
        backgroundColor: "#eaf4fb",
    },
};

const ascDescForm = () => {
    const asc = filtOrders.asc || "desc";
    return (
        <div className="my-4">
            <div className="m-0 p-1" style={{ backgroundColor: "WhiteSmoke" }}>
                <h5 className="my-0 mx-1 p-1 fw-bold">
                    {infoSource.language(infoSource, "title", "descAsce")}
                </h5>
            </div>
            <div style={sortDirectionStyles.container}>
                <button
                    type="button"
                    style={{
                        ...sortDirectionStyles.button,
                        ...(asc === "asc" ? sortDirectionStyles.active : {}),
                    }}
                    onClick={() => setFiltOrders(prev => ({ ...prev, asc: "asc" }))}
                    aria-label={elakayAutoText("h_filersorder_asc", "Ascending")}
                >
                    <FcAlphabeticalSortingAz />
                </button>
                <button
                    type="button"
                    style={{
                        ...sortDirectionStyles.button,
                        ...(asc === "desc" ? sortDirectionStyles.active : {}),
                    }}
                    onClick={() => setFiltOrders(prev => ({ ...prev, asc: "desc" }))}
                    aria-label={elakayAutoText("h_filersorder_desc", "Descending")}
                >
                    <FcAlphabeticalSortingZa />
                </button>
            </div>
        </div>
    );
};

   



const statusForm = () => {
  return (
    <div className="my-4">
      <div className="m-0 p-1" style={{ backgroundColor: "WhiteSmoke" }}>
        <h5 className="my-0 mx-1 p-1 fw-bold">
          {/* Status */}
          {infoSource.laguangeElakay("title", infoSource.languageAPI).status}
        </h5>
      </div>

      {status.map((p, i) => {
        const isAllStatus = p.name === "allStatus";

        // config spéciale pour "All Status"
        const inputName = isAllStatus ? "allStatus" : "orderStatus";
        const inputValue = isAllStatus ? "All Status" : p.name;

        const checked = isAllStatus
          ? filtOrders.orderStatus.length === getStatusList().length // coche si tout sélectionné
          : filtOrders.orderStatus.includes(p.name);             // coche si ce status est dans le tableau

        return (
          <h5 key={i}>
            <input
              type="checkbox"
              className="form-check-input mr-2 ml-4 check2"
              id={"status_" + p.name.replace(/\s+/g, "_")}
              name={inputName}
              value={inputValue}
              checked={checked}
              onChange={handleChange}
            />
            <label
              className="form-check-label"
              htmlFor={"status_" + p.name.replace(/\s+/g, "_")}
            >
              {p.label}
            </label>
          </h5>
        );
      })}
    </div>
  );
};

    
const IncommeForm = () => {
  return (
    <div className="my-4">
      <div className="m-0 p-1" style={{ backgroundColor: "WhiteSmoke" }}>
        <h5 className="my-0 mx-1 p-1 fw-bold">
          {infoSource.laguangeElakay('title', infoSource.languageAPI).role}
        </h5>
      </div>

      {incommeList.map((p, i) => {
        const isAll = p.name === "allIncomme";

        // input name + value selon "all" ou normal
        const inputName = isAll ? "allIncomme" : "roneName";
        const inputValue = isAll ? "allIncomme" : p.name;

        // gestion checked
        const checked = isAll
          ? filtOrders.roneName.length === ROLE_LIST.length
          : filtOrders.roneName.includes(p.name);

        return (
          <h5 key={i}>
            <input
              onChange={handleChange}
              value={inputValue}
              name={inputName}
              type="checkbox"
              className="form-check-input mr-2 ml-4 check2"
              checked={checked}
              id={"roleName_" + p.name}
            />

            <label className="form-check-label" htmlFor={"roleName_" + p.name}>
              {p.label}
            </label>
          </h5>
        );
      })}
    </div>
  );
};


    const dateForm = ()=>{
        return<div className="my-4"> 
          <div className="m-0 p-1" style={{backgroundColor: "WhiteSmoke"}}>  <h5 className="my-0 mx-1  p-1 fw-bold fw-bold">
            {/* filter date */}
            {infoSource.laguangeElakay('title', infoSource.languageAPI).filterdate}
            </h5></div>
            {date?.map((p, i) => (
            <h5 key={i}>
                <input
                    onChange={handleChange}
                    value={`${p}`}
                    name="orderDate"
                    type="radio"
                    className="form-check-input mr-2 ml-4 check2"
                    checked={p == filtOrders.orderDate ? 'checked' : ''}
                    id={"date_" + p}
                />
                <label className="form-check-label"for={"date_" + p}>{p}</label>
            </h5>
        ))}
        </div>
    }
    
const orderBypageselect = () => {
  const pageOrder = [];
  const startNumber = 50;
  const endNumber = 2000;

  for (let number = startNumber; number <= endNumber; number += 50) {
    pageOrder.push(number);
  }

  return (
    <div className="my-4">
      <div className="m-0 p-1 mb-4" style={{ backgroundColor: "WhiteSmoke" }}>
        <h5 className="my-0 mx-1 p-1 fw-bold">
          {/* Number order by page */}
          {infoSource.laguangeElakay("title", infoSource.languageAPI).orderPage}
        </h5>
      </div>

      <select
        name="limit"
        value={filtOrders.limit}
        onChange={handleChange}
        className="w-50 m-4 form-select"
      >
        <option>
          {/* select number order by page */}
          {infoSource.laguangeElakay("title", infoSource.languageAPI).selOrderPage}
        </option>

        {pageOrder.map((c, i) => (
          <option key={i} value={c}>
            {c}
          </option>
        ))}

        <option key="Endless" value="Endless">{__elakayText("t023", "Endless")}</option>
      </select>
    </div>
  );
};



const daySelect = () => {
    const allDays = Array.from({ length: 31 }, (_, i) => i + 1);

    return (
        <div className="my-4">
            <div className="m-0 mb-4" style={{ backgroundColor: "WhiteSmoke" }}>
                <h5 className="my-0 mx-1 p-1 fw-bold">
                    {infoSource.laguangeElakay('title', infoSource.languageAPI).filterDays}
                </h5>
            </div>

            <select
                name="myd"
                value={filtOrders.myd}
                onChange={handleChange}
                className="w-50 m-4 form-select"
            >
                <option>
                    {infoSource.laguangeElakay('title', infoSource.languageAPI).selectdays}
                </option>

                {allDays.map((d) => (
                    <option key={d} value={d}>{d}</option>
                ))}
            </select>
        </div>
    );
};


const monthsSelect = () => {
    const allMonths = Array.from({ length: 12 }, (_, i) => i + 1);

    return (
        <div className="my-4">
            <div className="m-0 mb-4" style={{ backgroundColor: "WhiteSmoke" }}>
                <h5 className="my-0 mx-1 p-1 fw-bold">
                    {infoSource.laguangeElakay('title', infoSource.languageAPI).filterMonths}
                </h5>
            </div>

            <select
                name="myd"
                value={filtOrders.myd}
                onChange={handleChange}
                className="w-50 m-4 form-select"
            >
                <option>
                    {infoSource.laguangeElakay('title', infoSource.languageAPI).selectmonth}
                </option>

                {allMonths.map((m) => (
                    <option key={m} value={m}>{m}</option>
                ))}
            </select>
        </div>
    );
};


const yearsSelect = () => {
    const curYear = new Date().getFullYear();
    const allyears = [];

    for (let y = curYear; y >= curYear - 6; y--) allyears.push(y);

    return (
        <div className="my-4">
            <div className="m-0 mb-4" style={{ backgroundColor: "WhiteSmoke" }}>
                <h5 className="my-0 mx-1 p-1 fw-bold">
                    {infoSource.laguangeElakay('title', infoSource.languageAPI).filteryears}
                </h5>
            </div>

            <select
                name="myd"
                value={filtOrders.myd}
                onChange={handleChange}
                className="w-50 m-4 form-select"
            >
                <option>
                    {infoSource.laguangeElakay('title', infoSource.languageAPI).selectyear}
                </option>

                {allyears.map((y) => (
                    <option key={y} value={y}>{y}</option>
                ))}
            </select>
        </div>
    );
};


const dateSelect = () => {

    // obtenir la date du jour au format YYYY-MM-DD
    const today = new Date().toISOString().split("T")[0];

    return (
        <div className="my-4">
            <div className="m-0 mb-4" style={{ backgroundColor: "WhiteSmoke" }}>
                <h5 className="my-0 mx-1 p-1 fw-bold">
                    {infoSource.laguangeElakay('title', infoSource.languageAPI).Choosedate}
                </h5>
            </div>

            <input
                type="date"
                name="myd"
                value={filtOrders.myd || today}   // 🔥 valeur par défaut = aujourd'hui
                onChange={handleChange}
                className="form-control w-50 m-4"
            />
        </div>
    );
};
// const ordersReadyToPayForm = () => {
//   return (
//     <>
//       <div className="m-0 mb-4" style={{ backgroundColor: "WhiteSmoke" }}>
//         <h5 className="my-0 mx-1 p-1 fw-bold">
//           {/* Orders Ready to Pay */}
//           {infoSource.language(infoSource, "title", "ordersReadyToPay")}
//         </h5>
//       </div>

//       <label className="switch">
//         <input
//           type="checkbox"
//           name="OrdersReadyToPay"
//           checked={filtOrders.OrdersReadyToPay === true}
//           onChange={handleChange}
//           value={String(!filtOrders.OrdersReadyToPay)}
//         />
//         <span className="slider round"></span>
//       </label>
//     </>
//   );
// };

const ordersReadyToPayForm = () => {
  return (
    <>
      <div className="m-0 mb-4" style={{ backgroundColor: "WhiteSmoke" }}>
        <h5 className="my-0 mx-1 p-1 fw-bold">
          {infoSource.language(infoSource, "title", "ordersReadyToPay")}
        </h5>
      </div>

      <label className="switch">
        <input
          type="checkbox"
          name="OrdersReadyToPay"
          checked={filtOrders.OrdersReadyToPay}
          onChange={(e) => {
            const isChecked = e.target.checked;

            // 🔥 si ON → on force Delivered seulement
            if (isChecked) {
              setFiltOrders(prev => ({
                ...prev,
                OrdersReadyToPay: true,
                orderStatus: ["Delivered"]   // on force Delivered
              }));
            } 
            // 🔥 si OFF → on désactive sans toucher orderStatus
            else {
              setFiltOrders(prev => ({
                ...prev,
                OrdersReadyToPay: false
              }));
            }
          }}
        />
        <span className="slider round"></span>
      </label>
    </>
  );
};

const payForm = () => {
  return (
    <>
      <div className="m-0 mb-2" style={{ backgroundColor: "WhiteSmoke" }}>
        <h5 className="my-0 mx-1 p-1 fw-bold">{__elakayText("t001", "Payment Status")}</h5>
        <h6 className="my-0 mx-2" style={{ opacity: 0.7 }}>{__elakayText("t002", "Paid or Unpaid")}</h6>
      </div>

      <label className="switch">
        <input
          type="checkbox"
          name="pay"
          checked={filtOrders.pay === true}
          onChange={(e) => {
            const isChecked = e.target.checked;

            setFiltOrders(prev => ({
              ...prev,
              pay: isChecked   // true = Paid, false = Unpaid
            }));
          }}
        />
        <span className="slider round"></span>
      </label>
    </>
  );
};


    const btnForm = ()=>{
        return<div className="my-4"> 
                <button className="btn btn-dark rounded-3" onClick={btnClrfilter}>
                    {/* clear filter */}
                     {infoSource.laguangeElakay('Button', infoSource.languageAPI).clearfilter}
                </button>
                <button className="btn btn-dark rounded-3" onClick={btnfilter}>
                    {/* set filter */}
                    {infoSource.laguangeElakay('Button', infoSource.languageAPI).setfilter}
                </button>

               
        </div>
    }
    return ( 
        <>

        {orderBypageselect()}
        {ordersReadyToPayForm()}
        {filtOrders.OrdersReadyToPay && payForm()}
        {IncommeForm()}
        {statusForm()}
        {dateForm()}
        {filtOrders.orderDate === 'days' && daySelect()}
        {filtOrders.orderDate === 'months' && monthsSelect()}
        {filtOrders.orderDate === 'years' && yearsSelect()}
        {filtOrders.orderDate === 'date' && dateSelect()}
        {ascDescForm()}
        {btnForm()}
        </>
        )
}
export default FiltersIncomme;
